<template>
  <div class="top">
    <div class="sp">
      <select-place-modal
        ref="selectPlaceModal"
        :isActive="activePlaceModal"
        :places="places"
        @close="closePlaceModal"
        @add-place="addPlace"
      />
      <select-item-modal
        ref="selectFacilityTypeModal"
        item-name="施設"
        :isActive="activeFacilityTypeModal"
        :items="facilityTypes"
        @close="closeFacilityTypeModal"
        @add-item="addFacilityType"
      />
      <select-item-modal
        ref="selectSportsTypeModal"
        item-name="競技"
        :isActive="activeSportsTypeModal"
        :items="sportsTypes"
        @close="closeSportsTypeModal"
        @add-item="addSportsType"
      />
       <select-price-modal
        ref="selectPriceModal"
        :isActive="activePriceModal"
        :prices="prices"
        @close="closePriceModal"
        @add-price="addPrice"
      />
      <select-item-modal
        ref="selectTagModal"
        item-name="タグ"
        :isActive="activeTagModal"
        :items="tags"
        @close="closeTagModal"
        @add-item="addTag"
      />
      <select-availability-modal
        :items="availabilities"
        :isActive="activeAvailabilityModal"
        :isPaidUser="isPaidUser"
        :isAdmin="isAdmin"
        :hasCustomerId="hasCustomerId"
        @close="closeAvailabilityModal"
        @add-availability="addAvailability"
      />
      <require-login-modal
        :isActive="activeRequireLoginModal"
        @close="closeRequireLoginModal"
      ></require-login-modal>

      <div class="image-wrap">
        <div>
          <img @load="imageLoaded" width="100%" :src="`/images/SPTOP_1.png`">
          <div class="logo-on-image">
            <div ref="logo" class="logo center"><img width="280px" src="/images/logo_inverse.svg"></div>
            <div ref="catchcopy" class="catchcopy center"><b>今すぐスポーツ施設を検索</b></div>
            <div ref="divideSp" class="divide"></div>
            <div ref="appeal" class="appeal center"><b><!-- 全国 --><span style="font-size: 140%;">{{facilitiesCount}}</span>施設掲載中！</b></div>
          </div>
          </div>
        <div class="tab-container">
          <div :class="`tab-select ${isConditionTab ? 'selected' : 'unselected'}`" @click="isConditionTab = true">
            <div class="center tab-display">
              <div>
                <img width="43px" src="/images/doc_search.png">
              </div>
              <b>条件から探す</b>
            </div>
          </div>
          <div :class="`tab-select ${isConditionTab ? 'unselected' : 'selected'}`" @click="isConditionTab = true">
            <div class="center tab-display">
              <div>
                <img width="43px" src="/images/compass.png">
              </div>
              <b>地図から探す</b>
            </div>
          </div>
          <div ref="tab1" class="tab-content" v-if="isConditionTab">
            <search-form
              label="所在地"
              :items="placeItems"
              @delete-item="deletePlaceItem"
              @click-plus="openPlaceModal"
            ></search-form>
            <search-form
              label="施設"
              :items="facilityTypeItems"
              @delete-item="deleteFacilityItem"
              @click-plus="openFacilityTypeModal"
            ></search-form>
            <search-form
              label="競技"
              :items="sportsTypeItems"
              @delete-item="deleteSportsTypeItem"
              @click-plus="openSportsTypeModal"
            ></search-form>
            <search-form
              label="料金"
              :items="priceItems"
              @delete-item="deletePriceItem"
              @click-plus="openPriceModal"
            ></search-form>
            <search-form
              label="タグ"
              :items="tagItems"
              @delete-item="deleteTagItem"
              @click-plus="openTagModal"
            ></search-form>
            <search-form
              label="空き有り"
              :items="availabilityItems"
              @delete-item="deleteAvailabilityItem"
              @click-plus="isLogin ? openAvailabilityModal() : openRequireLoginModal()"
              :disabled="!isLogin"
            ></search-form>
            <div class="center mt-3">
              <button :onclick="`location.href='${facilitiesLink}'`" class="search-button">検索</button>
            </div>
          </div>
          <div class="tab-content" v-else>
            開発中
          </div>
        </div>
      </div>
      <div class="top-container">
        <div class="animation-wave" style="margin-bottom: 63px;">
          <tracking-banner
            url="/about_sporevo_plus"
            imageUrl="/images/sporevo_plus_top_banner.png"
            trackingName="sporevo_plus_top_banner"
          ></tracking-banner>
        </div>
        <div @click="scrollButton" class="center scroll-button">↑</div>
        <div>
          <div class="center"><h2 ref="title1"><span><b>スポレボ が 叶える未来</b></span></h2></div>
          <div class="center"><span ref="vertical1" class="vertical-line"></span></div>
          <div>
            <img ref="image1" width="100%" src="/images/top-sp1.png" />
          </div>
          <div class="top-message-box-sp1">
            <div ref="message1">
              <div class="center"><h3><b>スポーツ施設利用の障壁を取り除く</b></h3></div>
              <div>
                <p>スポーツ施設を利用しようと思ったとき、</p>
                <p>使えそうな施設を探すために、</p>
                <p>ネットサーフィンと電話を繰り返したことはありませんか？</p>
                <br>
                <p>▶︎ 近くの体育館の情報が知りたい！</p>
                <p>▶︎ 利用料金の安い野球場はどこだろう？</p>
                <p>▶︎ 今すぐ使える卓球場はないかな？</p>
                <p>▶︎ 雨でも使えるテニスコートを探したい！ など、</p>
                <br>
                <p>スポーツを愛する人の要望を叶えるために開設いたしました。</p>
              </div>
            </div>
          </div>
          <div>
            <img ref="image2" width="100%" src="/images/top-sp2.png" />
          </div>
          <div class="top-message-box-sp2">
            <div ref="message2">
              <div class="center"><h3><b>スポーツ施設利用に付加価値を</b></h3></div>
              <div>
                <p>スポーツ施設を利用する=スポーツをすること</p>
                <p>だけが目的ではありません。</p>
                <br>
                <p>▶︎ 仲間と集まる時間</p>
                <p>▶︎ 運動後の美味しいご飯とお酒</p>
                <p>▶︎ 近くの観光スポット     が目的でも良いのです。</p>
                <br>
                <p>全ての人がスポーツ施設を利用するきっかけを提供します。</p>
              </div>
            </div>
          </div>
          <div class="top-boss-message"> 
            <div ref="message3">
              <p>各ページのフォームを設置しておりますので、</p>
              <p>お気づきの点や施設情報をお寄せください。</p>
              <p>スポーツに関わる人全ての活動が</p>
              <p>より良いものになりますように。</p>
              <br>
              <p>スポレボ運営</p>
            </div>
          </div>
          <img ref="message4" width="100%" src="/images/dot-sp.png" />
          <div class="center mt-5"><h2 ref="title3"><span><b>スポレボ データマップ</b></span></h2></div>
          <div class="center"><span ref="vertical3" class="vertical-line"></span></div>
          <div class="center"><h3 style="margin-bottom: 3px;" ref="subTitle3"><b>＼ あなたの投稿でマップを完成させよう ／</b></h3></div>
          <!-- <div class="center" style="margin-bottom: 15px;"><p>1 施設の投稿につき 1 ポイントが貯まります！</p></div> -->
          <div ref="map" class="top-white-map">
            <div class="text-align: center">
              <japanMap
                :prefecture-facility-info="prefectureFacilityInfo"
                :canvas-width=320
                :canvas-height=320
                :scale=0.6
                :line-weight=0.8
              ></japanMap>
              <div class="top-white-map-message-sp center">
                <b>
                  <div>現在</div>
                  <div>{{places.length}}都道府県</div>
                  <div>{{facilitiesCount}}施設</div>
                  <div>掲載中！！！</div>
                </b>
              </div>
            </div>
          </div>
          <div class="center mt-4 mb-5" ref="facilityNewLinkButton1">
            <div style="font-size: 13px; font-weight: 700;" class="mb-1">▽みんなでスポレボを盛り上げよう▽</div>
            <a :href="isLogin ? '/facilities/new' : '/sign_up'" class="top-link-button" v-text="isLogin ? '新しい施設を登録する' : '会員登録して施設を投稿する'"></a>
          </div>
          <div class="sporevo-plus-pr">
            <div class="animation-wave orange"></div>
            <div class="top-new-flag">
              <img src="/images/top_new_flag.svg">
            </div>
            <div class="sporevo-plus-messages">
              <div>
                <div class="sporevo-plus-message">
                  <span class="sporevo-plus-message-large">スポーツ</span>
                  <span class="sporevo-plus-message-small">をもっと</span>
                  <span class="sporevo-plus-message-large sporevo-plus-message-orange">身近</span>
                  <span class="sporevo-plus-message-small">に。</span>
                </div>
                <div class="sporevo-plus-message">
                  <span class="sporevo-plus-message-large">スポレボ</span>
                  <span class="sporevo-plus-message-small">をもっと</span>
                  <span class="sporevo-plus-message-large sporevo-plus-message-orange">便利</span>
                  <span class="sporevo-plus-message-small">に。</span>
                </div>
              </div>
              <div>
                <img src="/images/sporevo-plus-logo.svg">
              </div>
              <div class="sporevo-plus-detail">
                せっかくスポーツを始めたのに、場所やら何やら手間になることが多い。仲間と楽しむために、もっと色々簡単にできたらいいのに。
                <br>
                <br>
                そんなみなさまのお悩みを、もっともっと解消するため、スポレボPlusは誕生しました！
              </div>
            </div>
            <div class="sporevo-plus-issue">
              <div class="sporevo-plus-issue-title">
                <img src="/images/sporevo-plus-supporter-title-1.png">
              </div>
              <div class="sporevo-plus-issue-contents">
                <div class="sporevo-plus-issue-content">
                  <img src="/images/sporevo-plus-supporter-img-1.png">
                  <div class="sporevo-plus-issue-content-text">
                    使いたい施設が
                    <span class="sporevo-plus-issue-content-text-orange">予約で埋まってて使えない！</span>
                  </div>
                </div>
                <div class="sporevo-plus-issue-content">
                  <img src="/images/sporevo-plus-supporter-img-2.png">
                  <div class="sporevo-plus-issue-content-text">
                    近場のスポーツ施設が
                    <span class="sporevo-plus-issue-content-text-orange">空いたら教えてほしい！</span>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="81" viewBox="0 0 24 81" fill="none">
                <g clip-path="url(#clip0_1053_49780)">
                  <path d="M24 0.475098L12 16.4751L0 0.475098H24Z" fill="#404448"/>
                  <path d="M24 32.4751L12 48.4751L0 32.4751H24Z" fill="#75B5AF"/>
                  <path d="M24 64.4751L12 80.4751L0 64.4751H24Z" fill="#EBAE1D"/>
                </g>
                <defs>
                  <clipPath id="clip0_1053_49780">
                    <rect width="24" height="80" fill="white" transform="translate(0 0.475098)"/>
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div class="sporevo-plus-point">
              <div class="sporevo-plus-point-title">
                <img src="/images/sporevo-plus-supporter-title-2.png">
              </div>
              <div class="sporevo-plus-point-content">
                <img src="/images/sporevo-plus-supporter-img-3.png">
              </div>
            </div>
            <div class="sporevo-plus-buttons">
              <div class="sporevo-plus-button">
                <a href="/order_confirm" style="text-decoration: none;">
                  <orange-button
                    :isDisplayRightArrow="!(isPaidUser || isAdmin)"
                    :disabled="(isPaidUser || isAdmin)"
                  >
                    <span v-if="(isPaidUser || isAdmin)">ご登録ありがとうございます!!</span>
                    <span v-else-if="isLogin && hasCustomerId">スポレボPlusに再度登録する</span>
                    <span v-else>スポレボPlusを無料で試してみる</span>
                  </orange-button>
                </a>
              </div>
              <div class="sporevo-plus-button">
                <a href="/about_sporevo_plus" target="_blank" style="text-decoration: none;">
                  <outline-button>
                    スポレボPlusをもっと詳しく!!
                  </outline-button>
                </a>
              </div>
            </div>
            <div class="sporevo-plus-annotations">
              <notice-annotation
                text="スポレボ内に掲載されている施設、かつ空き状況の取得が可能なものに限ります。取得状況は鋭意拡大中ですので、利用したい施設が対応しているか事前にご確認いただけますようお願いいたします。また現在未取得の施設でも、施設ページから空き状況の取得リクエストを受け付けております。お気軽にリクエストください。"
                number=1
              ></notice-annotation>
              <notice-annotation
                text="空き状況の通知は1日1回、昼の12時に送信されます。ただし、空き状況の更新はシステム上、1日1回を目安に自動で行われるため、各施設毎に取得時間が異なる場合があります。そのため、通知内容が最新情報とは異なる可能性もありますので、ご了承くださいますようお願いいたします。"
                number=2
              ></notice-annotation>
              <notice-annotation
                text="Google AdSenseによる広告が非表示となります。それ以外のスポレボパートナー様による一部広告やスポレボ運営からの告知広告などは表示される可能性がありますので、ご了承くださいますようお願いいたします。"
                number=3
              ></notice-annotation>
            </div>
            <div class="animation-wave"></div>
          </div>
          <div class="center mt-5"><h2 ref="title4"><span><b>スポレボ 公式SNS</b></span></h2></div>
          <div class="center"><span ref="vertical4" class="vertical-line"></span></div>
          <div class="center mb-2"><h3 ref="subTitle11"><b>＼ スポーツに関するお役立ち情報を発信中 ／</b></h3></div>
          <div>
            <div class="center mb-3" ref="snsMessage">
              <p>スポーツを普段している人も あまりしない人にも</p>
              <p>タメになるコンテンツを提供しています！</p>
              <p>スポーツの新しい発見ができるかも？！</p>
            </div>
            <div class="mb-5" ref="instagramEmbedded">
              <div class="pr-4 pl-4" v-if="instagramPermalink">
                <blockquote class="instagram-media" data-instgrm-captioned :data-instgrm-permalink="`${instagramPermalink}?utm_source=ig_embed&amp;utm_campaign=loading`" data-instgrm-version="14" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:300px; min-width:250px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:16px;"> <a href="https://www.instagram.com/p/CZOoy4PPXE-/?utm_source=ig_embed&amp;utm_campaign=loading" style=" background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;" target="_blank"> <div style=" display: flex; flex-direction: row; align-items: center;"> <div style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;"></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;"></div></div></div><div style="padding: 19% 0;"></div> <div style="display:block; height:50px; margin:0 auto 12px; width:50px;"><svg width="50px" height="50px" viewBox="0 0 60 60" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-511.000000, -20.000000)" fill="#000000"><g><path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"></path></g></g></g></svg></div><div style="padding-top: 8px;"> <div style=" color:#3897f0; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:550; line-height:18px;">この投稿をInstagramで見る</div></div><div style="padding: 12.5% 0;"></div> <div style="display: flex; flex-direction: row; margin-bottom: 14px; align-items: center;"><div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(0px) translateY(7px);"></div> <div style="background-color: #F4F4F4; height: 12.5px; transform: rotate(-45deg) translateX(3px) translateY(1px); width: 12.5px; flex-grow: 0; margin-right: 14px; margin-left: 2px;"></div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(9px) translateY(-18px);"></div></div><div style="margin-left: 8px;"> <div style=" background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 20px; width: 20px;"></div> <div style=" width: 0; height: 0; border-top: 2px solid transparent; border-left: 6px solid #f4f4f4; border-bottom: 2px solid transparent; transform: translateX(16px) translateY(-4px) rotate(30deg)"></div></div><div style="margin-left: auto;"> <div style=" width: 0px; border-top: 8px solid #F4F4F4; border-right: 8px solid transparent; transform: translateY(16px);"></div> <div style=" background-color: #F4F4F4; flex-grow: 0; height: 12px; width: 16px; transform: translateY(-4px);"></div> <div style=" width: 0; height: 0; border-top: 8px solid #F4F4F4; border-left: 8px solid transparent; transform: translateY(-4px) translateX(8px);"></div></div></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center; margin-bottom: 24px;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 224px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 144px;"></div></div></a><p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;"><a href="https://www.instagram.com/p/CZOoy4PPXE-/?utm_source=ig_embed&amp;utm_campaign=loading" style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none;" target="_blank">スポレボ / スポーツが好きな人向けに役立つ情報発信(@sporevo.jp)がシェアした投稿</a></p></div></blockquote>
              </div>
            </div>
          </div>
          <div class="center mb-2"><h3 ref="subTitle4"><b>公式LINEに参加して<br>＼ スポレボPlusになろう ／</b></h3></div>
          <div ref="support">
            <div class="center">
              <div>
                <p><b>サポーター特典</b></p>
                <p>▶︎ スポレボ の最新情報を受け取る</p>
                <p> 公式LINEにてコンテンツ追加や</p>
                <p>対応施設追加等の情報を受け取れます。</p>
                <p> また、運営メンバーにメッセージを送ることができます。</p>
                <br>
              </div>
            </div>
            <div class="center">
              <div>
                <a href="https://lin.ee/E3lmthi">
                  <img width="114px" class="mt-4" src="/images/line.png" />
                </a>
                <div class="mt-4 mb-4">
                  <p>※ アイコンをタップすると、LINEのページに遷移します。</p>
                </div>
              </div>
            </div>
          </div>
          <div class="center mb-2"><h3 ref="subTitle5"><b>＼ スポレボご紹介動画 公開中!! ／</b></h3></div>
          <div class="top-youtube-player pr-4 pl-4 mb-4">
            <iframe width="100%" height="100%" src="https://www.youtube.com/embed/8PUfSFisq-I?si=pmj68Kv5_IuDiTrQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
          <div v-show="articles.length > 0" class="top-articles-scroll-sp">
            <div class="center mb-1"><h2 ref="title11" style="margin-bottom: -5px; margin-top: 0px;"><span><b>Articles</b></span></h2></div>
            <div class="center"><p ref="subTitle12">記事を読む</p></div>
            <div class="center"><span ref="vertical12" class="vertical-line"></span></div>
            <div class="top-article-left-scroll-button-sp" @click="articleLeftScrollButton2">&lt;</div>
            <div class="top-article-right-scroll-button-sp" @click="articleRightScrollButton2">&gt;</div>
            <div ref="articleScroll2" class="top-articles-list-sp">
              <article-box-sp v-for="article in articles" :key="article.id" :article="article"></article-box-sp>
            </div>
            <div ref="allReadButton3" style="text-align: center;">
              <a href="/articles" class="top-all-read-button-sp mt-4">全ての記事を読む</a>
            </div>
          </div>
          <div class="top-content-sp">
            <div class="center mb-1"><h2 ref="title5" style="margin-bottom: -5px; margin-top: 0px;"><span><b>News</b></span></h2></div>
            <div class="center"><p ref="subTitle5">更新情報</p></div>
            <div class="center"><span ref="vertical5" class="vertical-line"></span></div>
            <div>
              <div v-for="notification in notifications" :key="notification.path" :ref="`notification${notification.path}`">
                <div class="notification-date-sp"><b>{{notification.released_at}}</b><span class="notification-category-sp">{{notification.notification_category}}</span></div>
                <div class="notification-title-sp"><a :href="notification.path">{{notification.title}}</a></div>
                <hr>
              </div>
            </div>
            <div v-show="notifications.length > 0" ref="allReadButton4" style="text-align: center;">
              <a href="/notifications" class="top-all-read-button-sp mt-4">全ての更新情報を見る</a>
            </div>

            <div class="center mb-1"><h2 ref="title13" style="margin-bottom: -5px; margin-top: 50px;"><span><b>Supporter</b></span></h2></div>
            <div class="center"><p ref="subTitle14">ご支援者様</p></div>
            <div class="center"><span ref="vertical14" class="vertical-line"></span></div>
            <div style="margin-bottom: 25px;" ref="image4">
              <a href="/supporter">
                <img src="/images/supporter-link-banner.png" width="100%">
              </a>
            </div>

          </div>
          <div class="center mt-5"><h2 ref="everyone"><span><b>スポレボは<br>スポーツを愛する人<br>みんなで作るサイトです。</b></span></h2></div>
          <div class="center"><span ref="vertical6" class="vertical-line"></span></div>
          <div class="center mt-5 mb-1"><h3 ref="subTitle6"><b>＼ スポレボをシェアしよう ／</b></h3></div>
          <div class="center" ref="snsIcons">
            <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/intent/tweet?text=%E3%82%B9%E3%83%9D%E3%83%BC%E3%83%84%E6%96%BD%E8%A8%AD%E3%82%92%E6%8E%A2%E3%81%99%E3%81%AA%E3%82%89スポレボ%21%21&url=https://spo-revo.com/&hashtags=スポレボ">
              <img width="10%" class="mr-2" src="/images/twitter_icon.png" />
            </a>
            <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/share.php?u=https://spo-revo.com">
              <img width="10%" class="mr-2" src="/images/facebook_icon.png" />
            </a>
            <a target="_blank" rel="noopener noreferrer" href="https://b.hatena.ne.jp/entry/panel/?url=https://spo-revo.com">
              <img width="10%" class="mr-2" src="/images/hatena_icon.png" />
            </a>
            <a target="_blank" rel="noopener noreferrer" href="http://pinterest.com/pin/create/button/?url=https://spo-revo.com">
              <img width="10%" class="mr-2" src="/images/pinterest_icon.png" />
            </a>
            <a target="_blank" rel="noopener noreferrer" href="https://social-plugins.line.me/lineit/share?url=https://spo-revo.com">
              <img width="10%" class="mr-2" src="/images/line_icon.png" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="pc">
      <div class="video-wrap">
        <video autoplay="autoplay" loop="loop" muted="muted" class="video-content" src="/videos/top.mp4"></video>
        <div class="content-on-video">
          <div class="card top-card fadein-from-bottom-backwords delay-1s">
            <div class="card-body"> 
              <div class="center mb-3" style="font-size: 20px; font-weight: 500; color: #263238;">条件からスポーツ施設を検索</div>
              <search-form
                label="所在地"
                :items="placeItems"
                @delete-item="deletePlaceItem"
                @click-plus="openPlaceModal"
              ></search-form>
              <select-place-modal
                ref="selectPlaceModal"
                :isActive="activePlaceModal"
                :places="places"
                @close="closePlaceModal"
                @add-place="addPlace"
              />
              <search-form
                label="施設"
                :items="facilityTypeItems"
                @delete-item="deleteFacilityItem"
                @click-plus="openFacilityTypeModal"
              ></search-form>
              <select-item-modal
                ref="selectFacilityTypeModal"
                item-name="施設"
                :isActive="activeFacilityTypeModal"
                :items="facilityTypes"
                @close="closeFacilityTypeModal"
                @add-item="addFacilityType"
              />
              <search-form
                label="競技"
                :items="sportsTypeItems"
                @delete-item="deleteSportsTypeItem"
                @click-plus="openSportsTypeModal"
              ></search-form>
              <select-item-modal
                ref="selectSportsTypeModal"
                item-name="競技"
                :isActive="activeSportsTypeModal"
                :items="sportsTypes"
                @close="closeSportsTypeModal"
                @add-item="addSportsType"
              />
              <search-form
                label="料金"
                :items="priceItems"
                @delete-item="deletePriceItem"
                @click-plus="openPriceModal"
              ></search-form>
              <select-price-modal
                ref="selectPriceModal"
                :isActive="activePriceModal"
                :prices="prices"
                @close="closePriceModal"
                @add-price="addPrice"
              />
              <search-form
                label="タグ"
                :items="tagItems"
                @delete-item="deleteTagItem"
                @click-plus="openTagModal"
              ></search-form>
              <select-item-modal
                ref="selectTagModal"
                item-name="タグ"
                :isActive="activeTagModal"
                :items="tags"
                @close="closeTagModal"
                @add-item="addTag"
              />
              <search-form
                label="空き有り"
                :items="availabilityItems"
                @delete-item="deleteAvailabilityItem"
                @click-plus="isLogin ? openAvailabilityModal() : openRequireLoginModal()"
                :disabled="!isLogin"
              ></search-form>
              <select-availability-modal
                :items="availabilities"
                :isActive="activeAvailabilityModal"
                @close="closeAvailabilityModal"
                @add-availability="addAvailability"
                :hasCustomerId="hasCustomerId"
                :isPaidUser="isPaidUser"
                :isAdmin="isAdmin"
              />
              <require-login-modal
                :isActive="activeRequireLoginModal"
                @close="closeRequireLoginModal"
              ></require-login-modal>
              <div class="center mt-3">
                <button :onclick="`location.href='${facilitiesLink}'`" class="search-button">検索</button>
              </div>
            </div>
          </div>
          <div class="fadein-from-bottom delay-2s" style="margin: auto;">
            <div class="logo">
              <div class="logo-wrap">
                <img width="72%" src="/images/logo_inverse.svg">
              </div>
              <div class="catchcopy center">今すぐスポーツ施設を検索</div>
              <div ref="dividePc" class="divide"></div>
              <div class="appeal center"><!--全国 --><b>{{facilitiesCount}}施設</b>掲載中！</div>
            </div>
          </div>
        </div>
      </div>
      <div class="top-container">
        <div class="animation-wave">
          <tracking-banner
            url="/about_sporevo_plus"
            imageUrl="/images/sporevo_plus_top_banner.png"
            trackingName="sporevo_plus_top_banner"
            maxWidth="400px"
          ></tracking-banner>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="center" ref="title6"><h2><b>スポレボ が 叶える未来</b></h2></div>
            <div class="center" ref="vertical7"><span class="vertical-line"></span></div>
          </div>
          <div class="mt-3 top-message-1">
            <div ref="pcMessage1" class="top-message-box">
              <div class="center"><h3><b>スポーツ施設利用の障壁を取り除く</b></h3></div>
              <div class="mt-5">
                <p>スポーツ施設を利用しようと思ったとき、</p>
                <p>使えそうな施設を探すために、</p>
                <p>ネットサーフィンと電話を繰り返したことはありませんか？</p>
                <br>
                <p>▶︎ 近くの体育館の情報が知りたい！</p>
                <p>▶︎ 利用料金の安い野球場はどこだろう？</p>
                <p>▶︎ 今すぐ使える卓球場はないかな？</p>
                <p>▶︎ 雨でも使えるテニスコートを探したい！ など、</p>
                <br>
                <p>スポーツを愛する人の要望を叶えるために開設いたしました。</p>
              </div>
            </div>
            <div ref="yellowImage" class="top-image-box">
              <img class="top-message-image" src="/images/top1.png" />
              <div class="top-yellow-ribbon" />
            </div>
          </div>
          <div class="mt-5 top-message-2">
            <div ref="blueImage" class="top-image-box">
              <img class="top-message-image" src="/images/top2.png" />
              <div class="top-blue-ribbon" />
            </div>
            <div ref="pcMessage2" class="top-message-box">
              <div class="center"><h3><b>スポーツ施設利用に付加価値を</b></h3></div>
              <div class="mt-5">
                <br>
                <p>スポーツ施設を利用する=スポーツをすること</p>
                <p>だけが目的ではありません。</p>
                <br>
                <p>▶︎ 仲間と集まる時間</p>
                <p>▶︎ 運動後の美味しいご飯とお酒</p>
                <p>▶︎ 近くの観光スポット    が目的でも良いのです。</p>
                <br>
                <p>全ての人がスポーツ施設を利用するきっかけを提供します。</p>
              </div>
            </div>
          </div>
        </div>
        <div ref="pcMessage3" class="row">
          <div class="col-md-12 mt-5">
            <div class="top-boss-message"> 
              <p>各ページのフォームを設置しておりますので、お気づきの点や施設情報をお寄せください。</p>
              <p>スポーツに関わる人全ての活動がより良いものになりますように。</p>
              <p class="float-right">スポレボ運営</p>
            </div>
          </div>
        </div>
      </div>
      <img ref="pcMessage4" width="100%" src="/images/dot.png" />
      <div class="container">
        <div class="row">
          <div class="col-md-12 center">
            <div ref="title8"><h2><b>スポレボ データマップ</b></h2></div>
            <div class="mt-3" ref="vertical9"><span class="vertical-line"></span></div>
          </div>
          <div class="col-md-12 center">
            <div class="mt-3 mb-2" ref="subTitle9" style="font-size: 160%;"><b>＼ あなたの投稿でマップを完成させよう ／</b></div>
            <!-- まだ見せない -->
            <!-- <div class="mt-3">１施設につき１ポイント貯まります。</div> -->
            <div ref="topMap" class="top-white-map">
              <div class="text-align: center">
                <japanMap
                :prefecture-facility-info="prefectureFacilityInfo"
                :canvas-width=560
                :canvas-height=560
                :scale=1.15
                :line-weight=1.5
                ></japanMap>
                <div class="top-white-map-message">
                  <b>
                    <div>現在</div>
                    <div class="mt-3">{{places.length}}都道府県</div>
                    <div class="mt-3">{{facilitiesCount}}施設</div>
                    <div class="mt-3">掲載中!!!</div>
                  </b>
                </div>
              </div>
            </div>
            <div ref="facilityNewLinkButton2" class="col-md-12 mb-5" style="text-align: right; padding-right: 65px;">
              <div class="center inline-block">
                <div style="font-size: 13px; font-weight: 700;" class="mb-1">▽みんなでスポレボを盛り上げよう▽</div>
                <a :href="isLogin ? '/facilities/new' : '/sign_up'" class="top-link-button" v-text="isLogin ? '新しい施設を登録する' : '会員登録して施設を投稿する'"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="top-container">
        <div class="sporevo-plus-pr">
          <div class="animation-wave orange"></div>
          <div class="top-new-flag">
            <img src="/images/top_new_flag.svg">
          </div>
          <div class="sporevo-plus-messages">
            <div>
              <div class="sporevo-plus-message">
                <span class="sporevo-plus-message-large">スポーツ</span>
                <span class="sporevo-plus-message-small">をもっと</span>
                <span class="sporevo-plus-message-large sporevo-plus-message-orange">身近</span>
                <span class="sporevo-plus-message-small">に。</span>
              </div>
              <div class="sporevo-plus-message">
                <span class="sporevo-plus-message-large">スポレボ</span>
                <span class="sporevo-plus-message-small">をもっと</span>
                <span class="sporevo-plus-message-large sporevo-plus-message-orange">便利</span>
                <span class="sporevo-plus-message-small">に。</span>
              </div>
            </div>
            <div>
              <img src="/images/sporevo-plus-logo.svg">
            </div>
            <div class="sporevo-plus-detail">
              せっかくスポーツを始めたのに、場所やら何やら手間になることが多い。<br>仲間と楽しむために、もっと色々簡単にできたらいいのに。
              <br>
              <br>
              そんなみなさまのお悩みを、もっともっと解消するため、スポレボPlusは誕生しました！
            </div>
          </div>
          <div class="sporevo-plus-issue">
            <div class="sporevo-plus-issue-title">
              <img src="/images/sporevo-plus-supporter-title-1.png">
            </div>
            <div class="sporevo-plus-issue-contents">
              <div class="sporevo-plus-issue-content">
                <img src="/images/sporevo-plus-supporter-img-1.png">
                <div class="sporevo-plus-issue-content-text">
                  使いたい施設が<br>
                  <span class="sporevo-plus-issue-content-text-orange">予約で埋まってて使えない！</span>
                </div>
              </div>
              <div class="sporevo-plus-issue-content">
                <img src="/images/sporevo-plus-supporter-img-2.png">
                <div class="sporevo-plus-issue-content-text">
                  近場のスポーツ施設が<br>
                  <span class="sporevo-plus-issue-content-text-orange">空いたら教えてほしい！</span>
                </div>
              </div>
            </div>
          </div>
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="81" viewBox="0 0 24 81" fill="none">
              <g clip-path="url(#clip0_1053_49780)">
                <path d="M24 0.475098L12 16.4751L0 0.475098H24Z" fill="#404448"/>
                <path d="M24 32.4751L12 48.4751L0 32.4751H24Z" fill="#75B5AF"/>
                <path d="M24 64.4751L12 80.4751L0 64.4751H24Z" fill="#EBAE1D"/>
              </g>
              <defs>
                <clipPath id="clip0_1053_49780">
                  <rect width="24" height="80" fill="white" transform="translate(0 0.475098)"/>
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="sporevo-plus-point">
            <div class="sporevo-plus-point-title">
              <img src="/images/sporevo-plus-supporter-title-2.png">
            </div>
            <div class="sporevo-plus-point-content">
              <img src="/images/sporevo-plus-supporter-img-4.svg">
            </div>
          </div>
          <div class="sporevo-plus-buttons">
            <div class="sporevo-plus-button">
              <a href="/order_confirm" style="text-decoration: none;">
                <orange-button
                  :isDisplayRightArrow="!(isPaidUser || isAdmin)"
                  :disabled="(isPaidUser || isAdmin)"
                >
                  <span v-if="(isPaidUser || isAdmin)">ご登録ありがとうございます!!</span>
                  <span v-else-if="isLogin && hasCustomerId">スポレボPlusに再度登録する</span>
                  <span v-else>スポレボPlusを無料で試してみる</span>
                </orange-button>
              </a>
            </div>
            <div class="sporevo-plus-button">
              <a href="/about_sporevo_plus" target="_blank" style="text-decoration: none;">
                  <outline-button>
                    スポレボPlusをもっと詳しく!!
                  </outline-button>
                </a>
            </div>
          </div>
          <div class="sporevo-plus-annotations">
            <div class="sporevo-plus-annotation">
              <notice-annotation
                text="スポレボ内に掲載されている施設、かつ空き状況の取得が可能なものに限ります。取得状況は鋭意拡大中ですので、利用したい施設が対応しているか事前にご確認いただけますようお願いいたします。また現在未取得の施設でも、施設ページから空き状況の取得リクエストを受け付けております。お気軽にリクエストください。"
                number=1
              ></notice-annotation>
            </div>
            <div class="sporevo-plus-annotation">
              <notice-annotation
                text="空き状況の通知は1日1回、昼の12時に送信されます。ただし、空き状況の更新はシステム上、1日1回を目安に自動で行われるため、各施設毎に取得時間が異なる場合があります。そのため、通知内容が最新情報とは異なる可能性もありますので、ご了承くださいますようお願いいたします。"
                number=2
              ></notice-annotation>
            </div>
            <div class="sporevo-plus-annotation">
              <notice-annotation
                text="Google AdSenseによる広告が非表示となります。それ以外のスポレボパートナー様による一部広告やスポレボ運営からの告知広告などは表示される可能性がありますので、ご了承くださいますようお願いいたします。"
                number=3
              ></notice-annotation>
            </div>
          </div>
          <div class="animation-wave"></div>
        </div>
      </div>
      <div class="container">
        <div class="row pb-4">
          <div class="col-md-12">
            <div class="center" ref="title9"><h2><b>スポレボ 公式SNS</b></h2></div>
            <div class="center mt-3" ref="vertical10"><span class="vertical-line"></span></div>
          </div>
          <div class="col-md-4 pr-5 mb-5 pt-5" ref="topSnsMessage" style="text-align: right;">
            <div class="top-sns-message">
              <b>
                <div>＼</div>
                <div class="mt-3">スポーツに関する</div>
                <div class="mt-3">お役立ち情報を発信中</div>
                <div class="mt-3 mb-4">／</div>
              </b>
            </div>
            <div>
              <p>スポーツを普段している人も あまりしない人にも</p>
              <p>タメになるコンテンツを提供しています！</p>
              <p>スポーツの新しい発見ができるかも？！</p>
            </div>
          </div>
          <div class="col-md-8 mb-5 sns-display" ref="topEmbeddedSns">
            <div v-if="instagramPermalink" style="height: 700px; overflow-y: auto;">
              <blockquote class="instagram-media" data-instgrm-captioned :data-instgrm-permalink="`${instagramPermalink}?utm_source=ig_embed&amp;utm_campaign=loading`" data-instgrm-version="14" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:300px; min-width:250px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:16px;"> <a href="https://www.instagram.com/p/CZOoy4PPXE-/?utm_source=ig_embed&amp;utm_campaign=loading" style=" background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;" target="_blank"> <div style=" display: flex; flex-direction: row; align-items: center;"> <div style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;"></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;"></div></div></div><div style="padding: 19% 0;"></div> <div style="display:block; height:50px; margin:0 auto 12px; width:50px;"><svg width="50px" height="50px" viewBox="0 0 60 60" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-511.000000, -20.000000)" fill="#000000"><g><path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"></path></g></g></g></svg></div><div style="padding-top: 8px;"> <div style=" color:#3897f0; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:550; line-height:18px;">この投稿をInstagramで見る</div></div><div style="padding: 12.5% 0;"></div> <div style="display: flex; flex-direction: row; margin-bottom: 14px; align-items: center;"><div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(0px) translateY(7px);"></div> <div style="background-color: #F4F4F4; height: 12.5px; transform: rotate(-45deg) translateX(3px) translateY(1px); width: 12.5px; flex-grow: 0; margin-right: 14px; margin-left: 2px;"></div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(9px) translateY(-18px);"></div></div><div style="margin-left: 8px;"> <div style=" background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 20px; width: 20px;"></div> <div style=" width: 0; height: 0; border-top: 2px solid transparent; border-left: 6px solid #f4f4f4; border-bottom: 2px solid transparent; transform: translateX(16px) translateY(-4px) rotate(30deg)"></div></div><div style="margin-left: auto;"> <div style=" width: 0px; border-top: 8px solid #F4F4F4; border-right: 8px solid transparent; transform: translateY(16px);"></div> <div style=" background-color: #F4F4F4; flex-grow: 0; height: 12px; width: 16px; transform: translateY(-4px);"></div> <div style=" width: 0; height: 0; border-top: 8px solid #F4F4F4; border-left: 8px solid transparent; transform: translateY(-4px) translateX(8px);"></div></div></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center; margin-bottom: 24px;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 224px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 144px;"></div></div></a><p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;"><a href="https://www.instagram.com/p/CZOoy4PPXE-/?utm_source=ig_embed&amp;utm_campaign=loading" style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none;" target="_blank">スポレボ / スポーツが好きな人向けに役立つ情報発信(@sporevo.jp)がシェアした投稿</a></p></div></blockquote>
            </div>
          </div>
          <div class="col-md-6" ref="topLineIcon">
            <div class="top-qr fadein center" v-show="isQrDisplayed" @mouseover="isQrDisplayed=true" @mouseout="isQrDisplayed=false">
              <div class="top-line-message">
                友だち追加はこちらから
              </div>
              <a href="https://lin.ee/E3lmthi">
                <img width="60%" class="mt-3 top-line-icon" src="/images/lineqr.png" />
              </a>
            </div>
            <div class="pr-3 center">
              <a href="https://lin.ee/E3lmthi">
                <img @mouseover="isQrDisplayed=true" width="40%" class="mt-3" src="/images/line.png" />
              </a>
              <div class="mt-3">
                アイコンをクリック・タップすると、<br>
                LINEのページに遷移します。
              </div>
            </div>
          </div>
          <div class="col-md-6 mb-5" ref="topLineMessage">
            <div class="top-line-message">
              <b>
                <div>／</div>
                <div class="mt-3">公式LINEに参加して</div>
                <div class="mt-3">スポレボPlusになろう</div>
                <div class="mt-3 mb-4">＼</div>
              </b>
            </div>
            <div>
              <p>サポーター特典</p>
              <p>▶︎ スポレボ の最新情報を受け取る</p>
              <p> 公式LINEにてコンテンツ追加や対応施設追加等の情報を受け取れます。</p>
              <p> また、運営メンバーにメッセージを送ることができます。</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="top-youtube-message">
              <b>
                <div>＼</div>
                <div class="mt-3">スポレボご紹介動画</div>
                <div class="mt-3">公開中!!</div>
                <div class="mt-3 mb-4">／</div>
              </b>
            </div>
          </div>
          <div class="col-md-8" style="padding: 0 60px;">
            <div class="top-youtube-player">
              <iframe width="100%" height="100%"src="https://www.youtube.com/embed/8PUfSFisq-I?si=pmj68Kv5_IuDiTrQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
          </div>
        </div>
      </div>
      <div v-show="articles.length > 0" class="top-articles-scroll">
        <div ref="topArticle" class="top-article-header"><span class="fs-30"><b>Articles</b></span><hr color="#A8ABA6" class="span-line"></span><span><b><span class="fs-20">記事を読む</span></b></span></div>
        <div ref="articleScroll1" @mousedown="setDragPoint" @mousemove="dragScroll" @mouseup="finDragScroll" @mouseleave="isShowScrollButton=false" @mouseover="isShowScrollButton=true" style="cursor: grab;">
          <div v-show="isShowScrollButton" class="top-article-left-scroll-button" @click="articleLeftScrollButton1">&lt;</div>
          <div v-show="isShowScrollButton" class="top-article-right-scroll-button" @click="articleRightScrollButton1">&gt;</div>
          <div ref="articleScroll" class="mt-4 top-articles-list" @dragstart="setDragPoint" @dragover="dragScroll" @dragend="finDragScroll">
            <article-box v-for="article in articles" :key="article.id" :article="article"></article-box>
          </div>
        </div>
        <div ref="allReadButton1" style="text-align: right; padding-right: 65px;">
          <a href="/articles" class="top-all-read-button">全ての記事を読む</a>
        </div>
      </div>
      <div class="top-white-background">
        <div>
          <div ref="topNotification"><span class="fs-30"><b>News</b></span><hr color="#A8ABA6" class="span-line"></span><span><b><span class="fs-20">更新情報</span></b></span></div>
          <div class="mt-4 ml-3">
            <div class="row d-flex align-items-center" v-for="notification in notifications" :key="notification.id" :ref="`topNotification${notification.id}`">
              <div class="col-md-4">{{notification.released_at}}<span class="notification-category">{{notification.notification_category}}</span></div>
              <div class="col-md-8"><b><a :href="notification.path">{{notification.title}}</a></b></div>
              <div class="col-md-12">
                <hr>
              </div>
            </div>
          </div>
          <div v-show="notifications.length > 0" ref="allReadButton2" style="text-align: right;" class="mt-4">
            <a href="/notifications" class="top-all-read-button">全ての更新情報を見る</a>
          </div>
          <div ref="topTeam" style="margin-top: 65px; margin-bottom: 56px;"><span class="fs-30"><b>Supporter</b></span><hr color="#A8ABA6" class="span-line"></span><span><b><span class="fs-20">ご支援者様</span></b></span></div>
          <div>
            <div ref="image6" class="center">
              <a href="/supporter">
                <img src="/images/supporter-link-banner.png" width="400px">
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="top-container">
        <div class="col-md-12">
          <div class="center" ref="title10"><h2><b>スポレボは<br>スポーツを愛する人みんなで作るサイトです。</b></h2></div>
          <div class="center mt-3" ref="vertical11"><span class="vertical-line"></span></div>
        </div>
        <div class="col-md-12 center">
          <div class="mt-3 mb-2" ref="subTitle10" style="font-size: 160%;"><b>＼ スポレボをシェアしよう ／</b></div>
          <a ref="snsIcon1" target="_blank" rel="noopener noreferrer" href="https://twitter.com/intent/tweet?text=%E3%82%B9%E3%83%9D%E3%83%BC%E3%83%84%E6%96%BD%E8%A8%AD%E3%82%92%E6%8E%A2%E3%81%99%E3%81%AA%E3%82%89スポレボ%21%21&url=https://spo-revo.com/&hashtags=スポレボ">
            <img width="5%" class="mt-3 mr-2" src="/images/twitter_icon.png" />
          </a>
          <a ref="snsIcon2" target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/share.php?u=https://spo-revo.com">
            <img width="5%" class="mt-3 mr-2" src="/images/facebook_icon.png" />
          </a>
          <a ref="snsIcon3" target="_blank" rel="noopener noreferrer" href="https://b.hatena.ne.jp/entry/panel/?url=https://spo-revo.com">
            <img width="5%" class="mt-3 mr-2" src="/images/hatena_icon.png" />
          </a>
          <a ref="snsIcon4" target="_blank" rel="noopener noreferrer" href="http://pinterest.com/pin/create/button/?url=https://spo-revo.com">
            <img width="5%" class="mt-3 mr-2" src="/images/pinterest_icon.png" />
          </a>
          <a ref="snsIcon5" target="_blank" rel="noopener noreferrer" href="https://social-plugins.line.me/lineit/share?url=https://spo-revo.com">
            <img width="5%" class="mt-3 mr-2" src="/images/line_icon.png" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import searchForm from './searchForm.vue'
import selectPlaceModal from './selectPlaceModal.vue'
import selectItemModal from './selectItemModal.vue'
import selectPriceModal from './selectPriceModal.vue'
import articleBox from './topArticleBox.vue'
import articleBoxSp from './topArticleBoxSp.vue'
import japanMap from './topJapanMap.vue'
import '../packs/require-login-modal'
import '../packs/select_availability_modal'
import '../packs/tracking_banner'
import '../packs/outline_button'
import '../packs/notice_annotation'
export default {
  data() {
    return {
      isShowScrollButton: false,
      placeItems: [],
      facilityTypeItems: [],
      sportsTypeItems: [],
      priceItems: [],
      tagItems: [],
      availabilityItems: [],
      activePlaceModal: false,
      activeFacilityModal: false,
      activeFacilityTypeModal: false,
      activeSportsTypeModal: false,
      activePriceModal: false,
      activeTagModal: false,
      activeAvailabilityModal: false,
      activeRequireLoginModal: false,
      isConditionTab: true,
      isQrDisplayed: false,
      beforeDragPoint: 0,
      inDrag: false,
    }
  },
  props: {
    places: {
      type: Array,
      default: () => []
    },
    facilityTypes: {
      type: Array,
      default: () => []
    },
    sportsTypes: {
      type: Array,
      default: () => []
    },
    prices: {
      type: Array,
      default: () => []
    },
    tags: {
      type: Array,
      default: () => []
    },
    facilitiesCount: {
      type: Number,
      default: 0
    },
    notifications: {
      type: Array,
      default: () => []
    },
    articles: {
      type: Array,
      default: () => []
    },
    prefectureFacilityInfo: {
      type: Array,
      default: () => []
    },
    instagramPermalink: {
      type: String,
      default: null
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    availabilities: {
      type: Array,
      default: () => []
    },
    isPaidUser: {
      type: Boolean,
      default: false
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    hasCustomerId: {
      type: Boolean,
      default: false
    },
  },
  components: {
    searchForm, selectPlaceModal, selectItemModal, selectPriceModal, articleBox, articleBoxSp, japanMap
  },
  methods: {
    scrollButton(){
      window.scroll({
        top: 0,
        behavior: "smooth"
      });
    },
    dragScroll(event){
      if(!this.inDrag) return;
      let scroll = this.$refs.articleScroll;
      scroll.scrollBy({
        left: (this.beforeDragPoint - event.clientX),
    })
      this.beforeDragPoint = event.clientX;
    },
    setDragPoint(event){
      this.inDrag = true;
      this.beforeDragPoint = event.clientX;
    },
    finDragScroll(event){
      this.inDrag = false;
    },
    articleLeftScrollButton1(){
      let scroll = this.$refs.articleScroll;
      scroll.scrollTo({
        left: scroll.scrollLeft - 972,
        behavior: "smooth"
      })
    },
    articleRightScrollButton1(){
      let scroll = this.$refs.articleScroll;
      scroll.scrollTo({
        left: scroll.scrollLeft + 972,
        behavior: "smooth"
      })
    },
    articleLeftScrollButton2(){
      let scroll = this.$refs.articleScroll2;
      scroll.scrollTo({
        left: scroll.scrollLeft - window.innerWidth,
        behavior: "smooth"
      })
    },
    articleRightScrollButton2(){
      let scroll = this.$refs.articleScroll2;
      scroll.scrollTo({
        left: scroll.scrollLeft + window.innerWidth,
        behavior: "smooth"
      })
    },
    imageLoaded(){
      const logo = this.$refs.logo;
      const catchcopy = this.$refs.catchcopy;
      const appeal = this.$refs.appeal;
      const divideSp = this.$refs.divideSp;
      const dividePc = this.$refs.dividePc;

      logo.classList.value = "logo center fadein-from-bottom delay-1s";
      catchcopy.classList.value = "catchcopy center fadein-from-bottom delay-2s";
      appeal.classList.value = "appeal center fadein-from-bottom delay-2s";
      divideSp.style.transform = "scaleX(1)";
      divideSp.style.transition = "all 0.7s";
      dividePc.style.transform = "scaleX(1)";
      dividePc.style.transition = "all 0.7s";
      
      const tabNums = [1];
      tabNums.forEach(num => {
        const tab = this.$refs[`tab${num}`]
        tab.style.transform = "translate(0, 0)";
        tab.style.transition = "all 2s cubic-bezier(0.22, 1, 0.36, 1) 2s";
        tab.style.opacity = 1;
      }) 
    },
    deletePlaceItem(id){
      this.placeItems = this.placeItems.filter(item => item.id != id)
      this.$refs.selectPlaceModal.$refs.selectAccordion.forEach(accordion => {
        const item = accordion.items.find(x => x.id == id);
        if(item){
          accordion.unSelectItemFromId(item.id)
        }
      });
    },
    deleteFacilityItem(id){
      this.facilityTypeItems = this.facilityTypeItems.filter(item => item.id != id);
      this.$refs.selectFacilityTypeModal.unSelectItemFromId(id)
    },
    deleteSportsTypeItem(id){
      this.sportsTypeItems = this.sportsTypeItems.filter(item => item.id != id);
      this.$refs.selectSportsTypeModal.unSelectItemFromId(id)
    },
    deletePriceItem(id){
      this.priceItems = this.priceItems.filter(item => item.id != id)
      this.$refs.selectPriceModal.$refs.selectAccordion.forEach(accordion => {
        const item = accordion.items.find(x => x.id == id);
        if(item){
          accordion.unSelectItemFromId(item.id)
        }
      });
    },
    deleteTagItem(id){
      this.tagItems = this.tagItems.filter(item => item.id != id);
      this.$refs.selectTagModal.unSelectItemFromId(id)
    },
    deleteAvailabilityItem(){
      this.availabilityItems = [];
    },
    openPlaceModal(){
      this.activePlaceModal = true;
    },
    closePlaceModal(){
      this.activePlaceModal = false;
    },
    addPlace(items){
      this.placeItems = items;
    },
    openFacilityTypeModal(){
      this.activeFacilityTypeModal = true;
    },
    closeFacilityTypeModal(){
      this.activeFacilityTypeModal = false;
    },
    addFacilityType(items){
      this.facilityTypeItems = items;
    },
    openSportsTypeModal(){
      this.activeSportsTypeModal = true;
    },
    closeSportsTypeModal(){
      this.activeSportsTypeModal = false;
    },
    addSportsType(items){
      this.sportsTypeItems = items;
    },
    openPriceModal(){
      this.activePriceModal = true;
    },
    closePriceModal(){
      this.activePriceModal = false;
    },
    addPrice(items){
      this.priceItems = items;
    },
    openTagModal(){
      this.activeTagModal = true;
    },
    closeTagModal(){
      this.activeTagModal = false;
    },
    addTag(items){
      this.tagItems = items;
    },
    openAvailabilityModal(){
      this.activeAvailabilityModal = true;
    },
    closeAvailabilityModal(){
      this.activeAvailabilityModal = false;
    },
    openRequireLoginModal(){
      console.log("open")
      this.activeRequireLoginModal = true;
    },
    closeRequireLoginModal(){
      this.activeRequireLoginModal = false;
    },
    addAvailability(item){
      this.availabilityItems = [item.detail];
    },
    handleScroll(){
      const tabNums = [1];
      const titleNums = [1,2,3,4,5,6,7,8,9,10,11,12,13];
      const messageNums = [1,2,3,4];
      const subTitleNums = [1,2,3,4,5,6,7,8,9,10,11,12,13,14];
      const hopeNums = [1,2,3,4];
      const verticalNums = [1,2,3,4,5,6,7,8,9,10,11,12,13,14];
      const snsIconNums = [1,2,3,4,5];
      const imageNums = [1,2,3,4,5,6];
      const articleScrollNums = [1,2];
      const allReadButtonNums = [1,2,3,4];
      const youtubeLinkButtonNums = [1,2];
      const facilityNewLinkButtonNums = [1,2];
      const scrollY = window.scrollY;
      const height = window.innerHeight; 

      tabNums.forEach(num => {
        const tab = this.$refs[`tab${num}`]
        const tabHeight = tab.getBoundingClientRect().y;
        if(tabHeight < height * 0.9){
          tab.style.transform = "translate(0, 0)";
          tab.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
          tab.style.opacity = 1;
        }
      })

      titleNums.forEach(num => {
        const title = this.$refs[`title${num}`]
        const titleHeight = title.getBoundingClientRect().y;
        if( titleHeight < height * 0.9){
          title.style.transform = "translate(0, 0)";
          title.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
          title.style.opacity = 1;
        }
      })

      imageNums.forEach(num => {
        const image = this.$refs[`image${num}`]
        const imageHeight = image.getBoundingClientRect().y;
        if(imageHeight < height * 0.9){
          image.style.transform = "translate(0, 0)";
          image.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
          image.style.opacity = 1;
        }
      })

      messageNums.forEach(num => {
        const message = this.$refs[`message${num}`]
        const messageHeight = message.getBoundingClientRect().y;
        if(messageHeight < height * 0.9){
          message.style.transform = "translate(0, 0)";
          message.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
          message.style.opacity = 1;
        }
      })

      subTitleNums.forEach(num => {
        const title = this.$refs[`subTitle${num}`]
        const titleHeight = title.getBoundingClientRect().y;
        if( titleHeight < height * 0.9){
          title.style.transform = "translate(0, 0)";
          title.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
          title.style.opacity = 1;
        }
      })

      hopeNums.forEach(num => {
        const hope = this.$refs[`hope${num}`]
        const hopeHeight = hope.getBoundingClientRect().y;
        if( hopeHeight < height * 0.9){
          hope.style.transform = "scale(1, 1)";
          hope.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
          hope.style.opacity = 1;
        }
      })
      const map = this.$refs.map;
      const mapHeight = map.getBoundingClientRect().y;
      if(mapHeight < height * 0.95){
        map.style.transform = "scale(1, 1)";
        map.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
        map.style.opacity = 1;
      }

      const support = this.$refs.support;
      const supportHeight = support.getBoundingClientRect().y;
      if(supportHeight < height * 0.9){
        support.style.transform = "translate(0, 0)";
        support.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
        support.style.opacity = 1;
      }

      const everyone = this.$refs.everyone;
      const everyoneHeight = everyone.getBoundingClientRect().y;
      if(everyoneHeight < height * 0.9){
        everyone.style.transform = "scale(1, 1)";
        everyone.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
        everyone.style.opacity = 1;
      }

      const icons = this.$refs.snsIcons;
      const iconsHeight = icons.getBoundingClientRect().y;
      if(iconsHeight < height * 0.9){
        icons.style.transform = "translate(0, 0)";
        icons.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
        icons.style.opacity = 1;
      }

      this.notifications.forEach((n,i) => {
        const notification = this.$refs[`notification${n.id}`][0]
        const notificationHeight = notification.getBoundingClientRect().y;
        if(notificationHeight < height * 0.9){
          notification.style.transform = "translate(0, 0)";
          notification.style.transition = `cubic-bezier(0.22, 1, 0.36, 1) 2s`;
          notification.style.opacity = 1;
        }
      })
      verticalNums.forEach(num => {
        const vertical = this.$refs[`vertical${num}`]
        const verticalHeight = vertical.getBoundingClientRect().y;
        if(verticalHeight < height * 0.95){
          vertical.style.transform = "translate(0, 0)";
          vertical.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
          vertical.style.opacity = 1;
        }
      })
      
      const pcMessage1 = this.$refs.pcMessage1;
      if(pcMessage1.getBoundingClientRect().y < height * 0.8){
        pcMessage1.style.transform = "translate(0, 0)";
        pcMessage1.style.transition = "all 2s cubic-bezier(0.22, 1, 0.36, 1) 1s";
        pcMessage1.style.opacity = 1;
      }

      const yellowImage = this.$refs.yellowImage;
      if(yellowImage.getBoundingClientRect().y < height * 0.8){
        yellowImage.style.transform = "translate(0, 0)";
        yellowImage.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
        yellowImage.style.opacity = 1;
      }

      const pcMessage2 = this.$refs.pcMessage2;
      if(pcMessage2.getBoundingClientRect().y < height * 0.8){
        pcMessage2.style.transform = "translate(0, 0)";
        pcMessage2.style.transition = "all 2s cubic-bezier(0.22, 1, 0.36, 1) 1s";
        pcMessage2.style.opacity = 1;
      }

      const blueImage = this.$refs.blueImage;
      if(blueImage.getBoundingClientRect().y < height * 0.8){
        blueImage.style.transform = "translate(0, 0)";
        blueImage.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
        blueImage.style.opacity = 1;
      }

      const pcMessage3 = this.$refs.pcMessage3;
      if(pcMessage3.getBoundingClientRect().y < height * 0.8){
        pcMessage3.style.transform = "translate(0, 0)";
        pcMessage3.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
        pcMessage3.style.opacity = 1;
      }

      const pcMessage4 = this.$refs.pcMessage4;
      if(pcMessage4.getBoundingClientRect().y < height * 0.8){
        pcMessage4.style.transform = "translate(0, 0)";
        pcMessage4.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
        pcMessage4.style.opacity = 1;
      }

      const search = this.$refs.search;
      if(search.getBoundingClientRect().y < height * 0.8){
        search.style.transform = "translate(0, 0)";
        search.style.transition = "all 2s cubic-bezier(0.22, 1, 0.36, 1) 0.5s";
        search.style.opacity = 1;
      }

      const reserve = this.$refs.reserve;
      if(search.getBoundingClientRect().y < height * 0.8){
        reserve.style.transform = "translate(0, 0)";
        reserve.style.transition = "all 2s cubic-bezier(0.22, 1, 0.36, 1) 1s";
        reserve.style.opacity = 1;
      }

      const pay = this.$refs.pay;
      if(search.getBoundingClientRect().y < height * 0.8){
        pay.style.transform = "translate(0, 0)";
        pay.style.transition = "all 2s cubic-bezier(0.22, 1, 0.36, 1) 1.5s";
        pay.style.opacity = 1;
      }

      const cashback = this.$refs.cashback;
      if(cashback.getBoundingClientRect().y < height * 0.9){
        cashback.style.transform = "translate(0, 0)";
        cashback.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
        cashback.style.opacity = 1;
      }

      const topMap = this.$refs.topMap;
      if(topMap.getBoundingClientRect().y < height * 1.0){
        topMap.style.transform = "translate(0, 0)";
        topMap.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
        topMap.style.opacity = 1;
      }

      const topLineIcon = this.$refs.topLineIcon;
      if(topLineIcon.getBoundingClientRect().y < height * 1.0){
        topLineIcon.style.transform = "translate(0, 0)";
        topLineIcon.style.transition = "all 2s cubic-bezier(0.22, 1, 0.36, 1) 0.5s";
        topLineIcon.style.opacity = 1;
      }

      const topLineMessage = this.$refs.topLineMessage;
      if(topLineIcon.getBoundingClientRect().y < height * 1.0){
        topLineMessage.style.transform = "translate(0, 0)";
        topLineMessage.style.transition = "all 2s cubic-bezier(0.22, 1, 0.36, 1) 1.0s";
        topLineMessage.style.opacity = 1;
      }

      const topEmbeddedSns = this.$refs.topEmbeddedSns;
      if(topEmbeddedSns.getBoundingClientRect().y < height * 1.0){
        topEmbeddedSns.style.transform = "translate(0, 0)";
        topEmbeddedSns.style.transition = "all 2s cubic-bezier(0.22, 1, 0.36, 1) 0.5s";
        topEmbeddedSns.style.opacity = 1;
      }

      const topSnsMessage = this.$refs.topSnsMessage;
      if(topEmbeddedSns.getBoundingClientRect().y < height * 1.0){
        topSnsMessage.style.transform = "translate(0, 0)";
        topSnsMessage.style.transition = "all 2s cubic-bezier(0.22, 1, 0.36, 1) 1.0s";
        topSnsMessage.style.opacity = 1;
      }

      const snsMessage = this.$refs.snsMessage;
      if(snsMessage.getBoundingClientRect().y < height * 1.0){
        snsMessage.style.transform = "translate(0, 0)";
        snsMessage.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
        snsMessage.style.opacity = 1;
      }

      const instagramEmbedded = this.$refs.instagramEmbedded;
      if(instagramEmbedded.getBoundingClientRect().y < height * 0.5){
        instagramEmbedded.style.transform = "translate(0, 0)";
        instagramEmbedded.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
        instagramEmbedded.style.opacity = 1;
      }

      const topNotification = this.$refs.topNotification;
      if(topNotification.getBoundingClientRect().y < height * 0.9){
        topNotification.style.transform = "translate(0, 0)";
        topNotification.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
        topNotification.style.opacity = 1;
      }

      this.notifications.forEach((n,i) => {
        const topNotificationItem = this.$refs[`topNotification${n.id}`][0]
        if(topNotificationItem.getBoundingClientRect().y < height * 0.9){
          topNotificationItem.style.transform = "translate(0, 0)";
          topNotificationItem.style.transition = `cubic-bezier(0.22, 1, 0.36, 1) 2s`;
          topNotificationItem.style.opacity = 1;
        }
      })

      snsIconNums.forEach((num, i) => {
        const icon = this.$refs[`snsIcon${num}`]
        if(icon.getBoundingClientRect().y < height * 0.9){
          icon.style.transform = "translate(0, 0)";
          icon.style.transition = `all 2s cubic-bezier(0.22, 1, 0.36, 1) ${i*0.2}s`;
          icon.style.opacity = 1;
        }
      })

      const topArticle = this.$refs.topArticle;
      if(topArticle.getBoundingClientRect().y < height * 0.9){
        topArticle.style.transform = "translate(0, 0)";
        topArticle.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
        topArticle.style.opacity = 1;
      }

      articleScrollNums.forEach((num, i) => {
        const articleScroll = this.$refs[`articleScroll${num}`]
        if(articleScroll.getBoundingClientRect().y < height * 0.9){
          articleScroll.style.transform = "translate(0, 0)";
          articleScroll.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
          articleScroll.style.opacity = 1;
        }
      })

      allReadButtonNums.forEach(num => {
        const button = this.$refs[`allReadButton${num}`]
        const buttonHeight = button.getBoundingClientRect().y;
        if(buttonHeight < height * 0.9){
          button.style.transform = "translate(0, 0)";
          button.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
          button.style.opacity = 1;
        }
      })

      youtubeLinkButtonNums.forEach(num => {
        const button = this.$refs[`youtubeLinkButton${num}`]
        const buttonHeight = button.getBoundingClientRect().y;
        if(buttonHeight < height * 0.9){
          button.style.transform = "translate(0, 0)";
          button.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
          button.style.opacity = 1;
        }
      })

      facilityNewLinkButtonNums.forEach(num => {
        const button = this.$refs[`facilityNewLinkButton${num}`]
        const buttonHeight = button.getBoundingClientRect().y;
        if(buttonHeight < height * 0.9){
          button.style.transform = "translate(0, 0)";
          button.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
          button.style.opacity = 1;
        }
      })

      const topReccomend = this.$refs.topReccomend;
      if(topReccomend.getBoundingClientRect().y < height * 0.9){
        topReccomend.style.transform = "translate(0, 0)";
        topReccomend.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
        topReccomend.style.opacity = 1;
      }

      const topTeam= this.$refs.topTeam;
      if(topTeam.getBoundingClientRect().y < height * 0.9){
        topTeam.style.transform = "translate(0, 0)";
        topTeam.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
        topTeam.style.opacity = 1;
      }

      const topPartner= this.$refs.topPartner;
      if(topPartner.getBoundingClientRect().y < height * 0.9){
        topPartner.style.transform = "translate(0, 0)";
        topPartner.style.transition = "cubic-bezier(0.22, 1, 0.36, 1) 2s";
        topPartner.style.opacity = 1;
      }

    }
  },
  mounted(){
    const insta = document.createElement('script');
    insta.src = '//www.instagram.com/embed.js';
    this.$el.appendChild(insta);

    const twitter = document.createElement('script');
    twitter.src = 'https://platform.twitter.com/widgets.js';
    this.$el.appendChild(twitter);

    window.addEventListener("scroll", this.handleScroll);
    const titleNums = [1,2,3,4,5,6,7,8,9,10,11,12,13];
    titleNums.forEach(num => {
      const title = this.$refs[`title${num}`]
        title.style.transform = "translate(0, 30px)";
        title.style.opacity = 0;
    })

    const imageNums = [1,2,3,4,5,6];
    imageNums.forEach(num => {
      const image = this.$refs[`image${num}`]
      image.style.transform = "translate(0, 30px)";
      image.style.opacity = 0;
    })

    const messageNums = [1,2,3,4];
    messageNums.forEach(num => {
      const message = this.$refs[`message${num}`]
      message.style.transform = "translate(0, 30px)";
      message.style.opacity = 0;
    })

    const verticalNums = [1,2,3,4,5,6,7,8,9,10,11,12,13,14];
    verticalNums.forEach(num => {
      const vertical = this.$refs[`vertical${num}`]
      vertical.style.transform = "translate(0, 30px)";
      vertical.style.opacity = 0;
    })

    const subTitleNums = [1,2,3,4,5,6,7,8,9,10,11,12,13,14];
    subTitleNums.forEach(num => {
      const title = this.$refs[`subTitle${num}`]
      title.style.transform = "translate(0, 30px)";
      title.style.opacity = 0;
    })

    const hopeNums = [1,2,3,4];
    hopeNums.forEach(num => {
      const hope = this.$refs[`hope${num}`]
      hope.style.transform = "scale(0, 0)";
      hope.style.opacity = 0;
    })

    const map = this.$refs.map;
    map.style.transform = "scale(0, 0)";
    map.style.opacity = 0;

    const support = this.$refs.support;
    support.style.transform = "translate(0, 30px)";
    support.style.opacity = 0;

    this.notifications.forEach((n,i) => {
      const notification = this.$refs[`notification${n.id}`][0]
      notification.style.transform = "translate(0, 30px)";
      notification.style.opacity = 0;
    })

    const everyone = this.$refs.everyone;
    everyone.style.transform = "scale(0, 0)";
    everyone.style.opacity = 0;

    const icons = this.$refs.snsIcons;
    icons.style.transform = "translate(0, 30px)";
    icons.style.opacity = 0;

    const pcMessage1 = this.$refs.pcMessage1;
    pcMessage1.style.transform = "translate(30px, 0)";
    pcMessage1.style.opacity = 0;

    const yellowImage = this.$refs.yellowImage;
    yellowImage.style.transform = "translate(30px, 0)";
    yellowImage.style.opacity = 0;

    const pcMessage2 = this.$refs.pcMessage2;
    pcMessage2.style.transform = "translate(-30px, 0)";
    pcMessage2.style.opacity = 0;

    const blueImage = this.$refs.blueImage;
    blueImage.style.transform = "translate(-30px, 0)";
    blueImage.style.opacity = 0;

    const pcMessage3 = this.$refs.pcMessage3;
    pcMessage3.style.transform = "translate(0, 30px)";
    pcMessage3.style.opacity = 0;

    const pcMessage4 = this.$refs.pcMessage4;
    pcMessage4.style.transform = "translate(0, 30px)";
    pcMessage4.style.opacity = 0;

    const search = this.$refs.search;
    search.style.transform = "translate(0, 30px)";
    search.style.opacity = 0;

    const reserve = this.$refs.reserve;
    reserve.style.transform = "translate(0, 30px)";
    reserve.style.opacity = 0;

    const pay = this.$refs.pay;
    pay.style.transform = "translate(0, 30px)";
    pay.style.opacity = 0;

    const cashback = this.$refs.cashback;
    cashback.style.transform = "translate(0, 30px)";
    cashback.style.opacity = 0;

    const topMap = this.$refs.topMap;
    topMap.style.transform = "translate(0, 30px)";
    topMap.style.opacity = 0;

    const topLineIcon = this.$refs.topLineIcon;
    topLineIcon.style.transform = "translate(-30px, 0)";
    topLineIcon.style.opacity = 0;

    const topLineMessage = this.$refs.topLineMessage;
    topLineMessage.style.transform = "translate(-30px, 0)";
    topLineMessage.style.opacity = 0;

    const topEmbeddedSns = this.$refs.topEmbeddedSns;
    topEmbeddedSns.style.transform = "translate(30px, 0)";
    topEmbeddedSns.style.opacity = 0;

    const topSnsMessage = this.$refs.topSnsMessage;
    topSnsMessage.style.transform = "translate(30px, 0)";
    topSnsMessage.style.opacity = 0;

    const snsMessage = this.$refs.snsMessage;
    snsMessage.style.transform = "translate(0, 30px)";
    snsMessage.style.opacity = 0;

    const instagramEmbedded = this.$refs.instagramEmbedded;
    instagramEmbedded.style.transform = "translate(0, 30px)";
    instagramEmbedded.style.opacity = 0;
  
    const topNotification= this.$refs.topNotification;
    topNotification.style.transform = "translate(-30px, 0)";
    topNotification.style.opacity = 0;
    this.notifications.forEach((n,i) => {
      const topNotificationItem = this.$refs[`topNotification${n.id}`][0]
      topNotificationItem.style.transform = "translate(0, 30px)";
      topNotificationItem.style.opacity = 0;
    })

    const snsIconNums = [1,2,3,4,5];
    snsIconNums.forEach(num => {
      const icon = this.$refs[`snsIcon${num}`]
      icon.style.transform = "scale(0, 0)";
      icon.style.opacity = 0;
    })

    const topArticle = this.$refs.topArticle;
    topArticle.style.transform = "translate(-30px, 0)";
    topArticle.style.opacity = 0;

    const allReadButtonNums = [1,2,3,4];
    allReadButtonNums.forEach(num => {
      const button = this.$refs[`allReadButton${num}`]
      button.style.transform ="translate(0, 30px)";
      button.style.opacity = 0;
    })

    const youtubeLinkButtonNums = [1,2];
    youtubeLinkButtonNums.forEach(num => {
      const button = this.$refs[`youtubeLinkButton${num}`]
      button.style.transform ="translate(0, 30px)";
      button.style.opacity = 0;
    })

    const facilityNewLinkButtonNums = [1,2];
    facilityNewLinkButtonNums.forEach(num => {
      const button = this.$refs[`facilityNewLinkButton${num}`]
      button.style.transform ="translate(0, 30px)";
      button.style.opacity = 0;
    })

    const articleScrollNums = [1,2];
    articleScrollNums.forEach(num => {
      const articleScroll = this.$refs[`articleScroll${num}`]
      articleScroll.style.transform ="translate(0, 30px)";
      articleScroll.style.opacity = 0;
    })

    const topReccomend = this.$refs.topReccomend;
    topReccomend.style.transform = "translate(-30px, 0)";
    topReccomend.style.opacity = 0;

    const topTeam = this.$refs.topTeam;
    topTeam.style.transform = "translate(-30px, 0)";
    topTeam.style.opacity = 0;

    const topPartner = this.$refs.topPartner;
    topPartner.style.transform = "translate(-30px, 0)";
    topPartner.style.opacity = 0;

  },
  computed: {
    randomNumber(){
      return Math.floor(Math.random() * 11 + 1);
    },
    availabilityStartDate(){
      return this.availabilityItems.length > 0 ? this.availabilityItems[0].startDate : null
    },
    availabilityEndDate(){
      return this.availabilityItems.length > 0 ? this.availabilityItems[0].endDate : null
    },
    facilitiesLink(){
      const params = new URLSearchParams({
        page: 1,
        q: JSON.stringify({
          city_id_eq_any: this.placeItems.map(x => x.id),
          sports_types_id_eq_any: this.sportsTypeItems.map(x => x.id),
          facility_type_id_eq_any: this.facilityTypeItems.map(x => x.id),
          price_ranges_id_eq_any: this.priceItems.map(x => x.id),
          tags_id_eq_any: this.tagItems.map(x => x.id),
          availabilities_start_date_gteq: this.availabilityStartDate,
          availabilities_end_date_lteq: this.availabilityEndDate
        })
      }).toString()
      return `/facilities?${params}`
    }
  },
  watch: {

  }
}
</script>
